import { graphql } from '@/gql'
export const PrinterJobMutation = graphql(`
  mutation GalleyPrintPackingLabel($restaurantId: ID!, $input: PrinterJobInput!) {
    createPrinterJob(restaurantId: $restaurantId, input: $input) { id }
  }
`)
